import { motion } from "framer-motion";

const item = {
  hidden: { opacity: 0, y: 6 },
  show: { opacity: 1, y: 0, transition: { duration: 0.16 } },
};

export default function UsagePolicy() {
  return (
    <section className="mb-12 space-y-4 text-gray-700 text-[15px] leading-relaxed">
      <motion.h2
        className="text-2xl font-bold text-gray-800 mb-2"
        variants={item}
        initial="hidden"
        animate="show"
      >
        Quy định sử dụng hệ thống
      </motion.h2>

      <motion.p variants={item} initial="hidden" animate="show">
        Việc sử dụng hệ thống này đồng nghĩa với việc người dùng chấp nhận tuân
        thủ toàn bộ các quy định được đề cập tại đây...
      </motion.p>

      <motion.ul
        className="list-disc list-inside ml-5 space-y-1"
        variants={item}
        initial="hidden"
        animate="show"
      >
        <li>
          Đăng tải nội dung vi phạm pháp luật, xúc phạm danh dự tổ chức/cá nhân
          khác.
        </li>
        <li>
          Sử dụng công cụ tự động để tạo/spam tài khoản, hoặc phá hoại hệ thống.
        </li>
        <li>Giả mạo danh tính, bác sĩ, nhân viên hỗ trợ hoặc bên cung cấp.</li>
        <li>
          Can thiệp hoặc tìm cách truy cập trái phép vào dữ liệu, tài khoản
          khác.
        </li>
      </motion.ul>

      <motion.p variants={item} initial="hidden" animate="show">
        Chúng tôi có quyền phối hợp với cơ quan pháp luật khi phát hiện hành vi
        có dấu hiệu lừa đảo, giả mạo...
      </motion.p>
    </section>
  );
}
